import React from 'react';

export const LazyCalculator = React.lazy(() =>
  import(
    /* webpackChunkName: 'InstallmentCalculator' */ '../../installmentCalculator/InstallmentCalculator'
  ).then((module) => ({ default: module.InstallmentCalculator })),
);
